// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:26:35

export default {
  "id": "the-counterfeit-bank",
  "slug": "the-counterfeit-bank",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1aa45e6dcab94b0bb795bf32ffa5b599-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1aa45e6dcab94b0bb795bf32ffa5b599/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "The Counterfeit Bank",
      "description": "The Counterfeit Bank: Fake Money Tycoon Simulator\nThink Plague Inc, but with counterfeit cash! Your goal: dominate the economy one fake note at a time.\nTaxes are soaring, inflation’s out of control, and recession looms—perfect chaos for your evil plan. Print counterfeit money, outsmart enforcers, and flood the market with fake cash to disrupt the system.\nCan you survive the chaos and take over the economy before time runs out? Mwahahaha!",
      "instructions": "Use front companies to hide your counterfeiting activities. Some are more profitable, others harder to detect. \nChoose your districts wisely. Some offer big rewards but are heavily enforced. Others provide easier inroads but lower returns.\nThey say, \"He who controls the money supply, controls the nation.\" The stakes are high. The clock is ticking. Tick tock. \n ",
      "genres": [
        "Strategy"
      ],
      "tags": [
        "business",
        "manager",
        "real-time-strategy",
        "tycoon"
      ]
    },
    "zh-CN": {
      "title": "假银行",
      "description": "《伪造银行：假钞大亨模拟器》\n想象一下《瘟疫公司》，但这次是假钞！你的目标：一次伪造一张钞票，逐步控制经济。\n税收飙升，通货膨胀失控，经济衰退即将到来——这是你邪恶计划的完美混乱。印刷假钞，智取执法者，向市场倾倒假钞，扰乱体系。\n你能在混乱中生存下来，在时间耗尽之前接管经济吗？哈哈哈！",
      "instructions": "利用前公司来隐藏你的仿造活动。有的公司利润更高，但更难被发现。\n明智地选择你的区域。有的区域提供丰厚的回报，但监管严格。其他区域更容易进入，但回报较低。\n他们常说：“谁控制了货币供应，谁就控制了国家。”风险很高。时钟在滴答作响。滴答，滴答。",
      "genres": [
        "策略"
      ],
      "tags": [
        "商业",
        "经理",
        "实时策略",
        "大亨"
      ]
    },
    "zh-TW": {
      "title": "偽造銀行",
      "description": "假銀行：偽幣大亨模擬器\n想一下《瘟疫公司》，但這次是偽幣！你的目標：一次印製一張偽鈔，逐漸統治經濟。\n稅收飆升，通脹失控，經濟衰退陰謀逼近——這正是你邪惡計劃的完美混亂。印製偽幣，智勝執法者，將偽鈔湧入市場以干擾體系。\n你能夠在時間耗盡前存活下來，並在經濟體中奪取領導地位嗎？哈哈！",
      "instructions": "利用前公司來掩蓋你的偽造活動。有些更獲利，有些則更難被發現。\n慎選你的地區。有些提供大獎勵但執法嚴格。其他則提供較容易進入但回報較低。\n他們說，「誰控制了貨幣供應，誰就控制了國家。」賭注很高。時鐘在滴答作響。滴答滴答。",
      "genres": [
        "策略"
      ],
      "tags": [
        "商業",
        "經理",
        "實時策略",
        "經營大亨"
      ]
    },
    "zh-HK": {
      "title": "偽造銀行",
      "description": "《偽造銀行：假幣巨頭模擬器》\n想遊玩《瘟疫公司》，但卻是假幣！你的目標：一次印一張假鈔，統治經濟。\n稅率飆升，通脹失控，經濟衰退陰霾籠罩——對你的邪惡計劃來說，正是完美的混亂。印製假幣，智勝執法者，將假鈔湧入市場，干擾體系。\n你能夠在時間耗盡前生存下來，並奪取經濟主導權嗎？哈哈！",
      "instructions": "利用前公司來掩飾你的偽造活動。有些更加有利可圖，但同時也較難被發現。\n明智選擇你的區域。有些會提供巨大的報酬，但同時執法嚴格。其他則提供較容易的進入途徑，但回報較低。\n他們說，「誰控制了貨幣供給，誰就控制了國家。」賭注很高。時鐘正在滴答作響。滴答滴答。",
      "genres": [
        "策略"
      ],
      "tags": [
        "商業",
        "經理人",
        "即時策略",
        "大亨"
      ]
    },
    "ja": {
      "title": "偽造銀行",
      "description": "The Counterfeit Bank: 偽札の大富豪シミュレーター\nPlague Inc.のようなゲームだが、偽札を使ったもの！あなたの目標は、一つの偽札ごとに経済を支配するすることだ。\n税金が急騰し、インフレが制御不能になり、景気後退が迫っている——あなたの邪悪な計画にとって完璧な混乱だ。偽札を作り、取締役をだます、市場に偽札を注ぎ込んでシステムを乱すのだ。\nこの混乱を生き延びて、時間が切れる前に経済を支配できるか？ハハハハハハハ！",
      "instructions": "フロント企業を使って偽造活動を隠そう。いくつかはより儲かるが、他のものは検出しにくい。\n地域を選ぶことに注意を払いなさい。いくつかは大きな報酬を提供するが、厳しく監視されている。他のものは入りやすいが、リターンは低い。\n「貨幣供給を支配する者は国を支配する」と言われる。リスクは高い。時間切れは刻々と迫っている。チック・トック。",
      "genres": [
        "戦略"
      ],
      "tags": [
        "ビジネス",
        "マネージャー",
        "リアルタイムストラテジー",
        "大企業家"
      ]
    },
    "ko": {
      "title": "의류은행",
      "description": "의 위조은행: 가짜 화폐 타이거너 시뮬레이터\nPlague Inc와 같은 게임을 생각해보세요, 하지만 가짜 화폐로! 목표: 한 가짜 지폐씩 경제를 장악하세요.\n세금이 치솟고, 인플레이션이 불어나고, 경제 침체가 도래하고 있습니다—좋은 혼란의 시기입니다. 가짜 화폐를印刷하고, 경찰을 속이고, 가짜 화폐로 시장을 가득 채워 시스템을 혼란에 빠뜨리세요.\n혼란 속에서도 살아남고 시간이 다되기 전에 경제를 장악할 수 있을까요? 하하하!",
      "instructions": "프론트 회사를 통해 위조 활동을 숨기세요. 일부는 더 큰 이익을 가져다주지만, 다른 것들은 더 어려운 탐지를 받습니다.\n지역을 지혜롭게 선택하세요. 일부는 큰 보상을 제공하지만 강력하게 단속됩니다. 다른 것들은 더 쉬운 진입을 제공하지만 낮은 수익을 가져옵니다.\n\"금융 공급을 통제하는 자는 국가를 통제한다\"고 말합니다. 위험이 높습니다. 시간이 지나고 있습니다. 틱톡.",
      "genres": [
        "전략"
      ],
      "tags": [
        "기업",
        "매니저",
        "실시간 전략",
        "대장장이"
      ]
    },
    "fr": {
      "title": "La Banque de Faux",
      "description": "La Banque de la Contrefaçon : Simulateur de Magnat de l'Argent Fausse\nPensez à Plague Inc, mais avec de la fausse monnaie ! Votre objectif : dominer l'économie une faux billet à la fois.\nLes impôts montent en flèche, l'inflation est hors de contrôle, et une récession plane - le chaos parfait pour votre plan maléfique. Imprimez de la fausse monnaie, déjouez les enforcers, et inondez le marché de faux billets pour perturber le système.\nPouvez-vous survivre au chaos et prendre le contrôle de l'économie avant que le temps ne se termine ? Ha ha ha !",
      "instructions": "Utilisez des sociétés écrans pour cacher vos activités de contrefaçon. Certaines sont plus lucratives, d'autres plus difficiles à détecter.\nChoisissez vos districts avec discernement. Certains offrent de grandes récompenses mais sont fortement réprimés. D'autres facilitent l'accès mais offrent des rendements plus bas.\nIls disent : \"Celui qui contrôle la monnaie contrôle le pays.\" Les risques sont élevés. L'horloge tic-tac.",
      "genres": [
        "Stratégie"
      ],
      "tags": [
        "affaires",
        "gestionnaire",
        "stratégie en temps réel",
        "magnat"
      ]
    }
  }
};
